<template>
  <div class="mx-auto">
    <div class="row mt-5 pt-lg-5">
      <div class="col-lg-6 pb-5 pt-1">
        <h1 class="font-weight-boldest mega-text">
          Beats your excel spreadsheet
        </h1>
        <h3 class="pt-2">
          Rental &amp; Property Management tool for smart Landlords, as little
          as $0.25 per property.
        </h3>
        <router-link
          :to="{ name: 'register' }"
          class="btn btn-primary btn-lg mt-4"
          >Get Started For Free <i class="lni lni-arrow-right ml-2"></i
        ></router-link>
        <br /><br />
        <p class="mt-3 text-success">
          Management of a single property is <strong> free! </strong>
        </p>
      </div>
      <div class="col-md-6 my-auto d-none d-lg-block">
        <img
          src="@/assets/img/undraw_Content_creator_re_pt5b.svg"
          class="img-fluid"
          alt="calender"
        />
      </div>
    </div>

    <div class="row my-5">
      <div class="col-md-4 my-3 h-100">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> ACCOUNTING</h5>
        Propli automatically emails your tenants their invoices on a daily, weekly or monthly basis.
        Track payments, credits and debits and produce PDF statements, as well as Accounts Payable.
      </div>

      <div class="col-md-4 my-3">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> LEASES</h5>
        Setup fixed term or month to month leases agreements. Attach lease documents as well as images of the property or inventory condition on lease initiation. Automated reminders on lease expiry.
      </div>

      <div class="col-md-4 my-3">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> EXPENSES</h5>
        Track expenses, such as maintenance repairs on your properties and link damages to a tenants profile as well as inventory items.
      </div>

      <div class="col-md-4 my-3">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> INVENTORY</h5>
        Tracking of items such as furniture and appliances.Ability to attach documents and images such as purchase invoices or warranty information. Setup maintenance reminders for items like smoke detectors. 
      </div>

      <div class="col-md-4 my-3">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> TENANTS</h5>
        Manage your tenants vital information  and attach important document such as ID copies and images to their profiles. Stored on secure Amazon AWS S3 storage.
      </div>

      <div class="col-md-4 my-3">
        <h5 class="font-weight-boldest"><i class="lni lni-checkmark-circle text-primary"></i> REPORTING</h5>
       Excel based reports on tenant, property, inventory and financial information. Weekly summaries straight to your  email inbox. 
      </div>
    </div>

    

    <div class="row my-2">
      <div class="col">
        <div class="border p-1">
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="2000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 1px #333"
          >
            <b-carousel-slide
              caption="Application dashboard"
              :img-src="screen3"
            ></b-carousel-slide>

            <b-carousel-slide
              caption="Property Management"
              :img-src="screen2"
            ></b-carousel-slide>

            <b-carousel-slide
              caption="Accounting"
              :img-src="screen1"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </div>

    <div class="row my-5 py-5">
      <div class="col-md-6">
        <h1 class="font-weight-boldest mega-text">
          Ready to simplify your life?
        </h1>
      </div>

      <div class="col-md-6 mt-3">
        <p>
          With our free tier you can manage a single property, manage tenants
          and leases. Additionally, you can keep track of your property expenses
          and property inventory.
        </p>

        <p>
          If you you looking to simplify your property management tasks, lets
          get started now.
        </p>
        <router-link
          :to="{ name: 'register' }"
          class="btn btn-primary btn-lg mb-5 mt-2"
          >Get Started For Free</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import screen3 from "../assets/img/screen-3.png";
import screen2 from "../assets/img/screen-2.png";
import screen1 from "../assets/img/screen-1.png";

export default {
  data() {
    return {
      slide: 0,
      screen3: screen3,
      screen2: screen2,
      screen1: screen1,
    };
  },
  methods: {},
};
</script>

